import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { setOnSale, setWithSubscription } from 'Pods/SearchPage/Store/actions/pricing'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import PriceInputs from './Components/PriceInputs/PriceInputs'
import RangeButtons from './Components/RangeButtons/RangeButtons'
import { pricingCheckboxFiltersConfig } from './constants'

function PriceContent() {
  const onSale = useSearchPageStore(state => state.onSale)
  const withSubscription = useSearchPageStore(state => state.withSubscription)

  const handleCheckboxFilterChange = useCallback((_, value, isOn) => {
    if (value === 'on_sale') {
      setOnSale(isOn)
    } else if (value === 'with_subscription') {
      setWithSubscription(isOn)
    }
  }, [])

  const selectedCheckboxFilters = useMemo(() => {
    const selected = []
    if (onSale) selected.push('on_sale')
    if (withSubscription) selected.push('with_subscription')
    return selected
  }, [onSale, withSubscription])

  return (
    <>
      <FiltersSidebar
        isCollapsible={false}
        filters={pricingCheckboxFiltersConfig}
        selectedFilters={selectedCheckboxFilters}
        onFiltersChange={handleCheckboxFilterChange}
        isControlled
        useNewCheckboxes
        hideLastDivider
        hideShowMore
        baseFormWrapperClassName="filter-wrapper__content"
      />
      <RangeButtons />
      <PriceInputs />
    </>
  )
}

PriceContent.propTypes = {}

export default memo(PriceContent)
